import { createReducer, on } from '@ngrx/store';
import { incrementLoading, decrementLoading } from './loading.action';

export interface LoadingState {
  loadingStates: { [context: string]: number };
}

const initialState: LoadingState = {
  loadingStates: {},
};

export const loadingReducer = createReducer(
  initialState,

  on(incrementLoading, (state, { context }) => ({
    ...state,
    loadingStates: {
      ...state.loadingStates,
      [context]: (state.loadingStates[context] || 0) + 1,
    },
  })),

  on(decrementLoading, (state, { context }) => ({
    ...state,
    loadingStates: {
      ...state.loadingStates,
      [context]: Math.max((state.loadingStates[context] || 0) - 1, 0),  // Ensure it's never negative
    },
  }))
);
